import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/inspectTaskList/page', Object.assign({}, options, { params }));

export const getDetail = (params, options) =>
  request.get('/api/inspectTaskList/detail', Object.assign({}, options, { params }));

export const remove = (params, options) =>
  request.post('/api/inspectTaskList/remove', qs.stringify(params), options);

export const add = (params, options) =>
  request.post('/api/inspectTaskList/submit', params, options);

export const update = (params, options) =>
  request.post('/api/inspectTaskList/update', params, options);

export const updateTaskStatus = (params, options) =>
  request.post('/api/inspectTaskList/updateTaskStatus', qs.stringify(params), options);
